var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircle3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 46,
    viewBox: "0 0 44 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.1639 33.6464L43.1732 33.6413H43.1551L32.5288 27.8833L21.8849 22.1152L11.2405 27.8833L0.614274 33.6413H0.596191L0.605443 33.6464L0.596191 33.6515H0.614274L11.2405 39.4094L21.8849 45.1775L32.5288 39.4094L43.1551 33.6515H43.1732L43.1639 33.6464Z",
    fill: "#72B0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1639 11.5312L43.1732 11.5265H43.1551L32.5288 5.76811L21.8849 0L11.2405 5.76811L0.614274 11.5265H0.596191L0.605443 11.5312L0.596191 11.5362H0.614274L11.2405 17.2946L21.8849 23.0627L32.5288 17.2946L43.1551 11.5362H43.1732L43.1639 11.5312Z",
    fill: "#0071E3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.614258 11.0625V34.1151L21.8849 22.589L0.614258 11.0625Z",
    fill: "#429AF2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.155 11.0625V34.1151L21.8848 22.589L43.155 11.0625Z",
    fill: "#429AF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle3);
export default __webpack_public_path__ + "static/media/circle3.3ff9eb088923c076b6d9adec633ae2cb.svg";
export { ForwardRef as ReactComponent };